//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSmallPlanar, getLargePlanar } from './utils'
export default {
    components: {
    },
    data () {
        return {
            x: 0,
            y: 0,
            scale: 1,
            img_loaded: false,
            show_tip: false,
            min_loaded: false
        }
    },
    props: {
        url: String
    },
    computed: {
        mini_img () {
            return getSmallPlanar(this.url)
        },
        large_img () {
            return getLargePlanar(this.url)
        }
    },
    methods: {
        changeScale (e) {
            console.error(e.detail)
            const {x, y } = e.detail
            this.x = x
            this.y = y
        },
        loadMinImg () {
            this.min_loaded = true
        },
        loadImg () {
            this.img_loaded = true
            this.show_tip = true
            setTimeout(() => {
                this.show_tip = false
            }, 3000)
        }
    }
}
